import CircularProgress from '@mui/material/CircularProgress';
import LoaderBackdrop from './LoaderBackdrop';

export interface Props {
  blur?: number;
  height?: string;
  isLoading?: boolean;
}

const Loader = ({ blur, height, isLoading = false }: Props) => (
  <LoaderBackdrop $isLoading={isLoading} blur={blur} height={height}>
    <CircularProgress color="info" />
  </LoaderBackdrop>
);

export default Loader;
